const errorsList = [
	{ title: 'company_phone_number incorrect format', description: 'Wrong the company phone number format' },
]

export const errorDetection = (errTitle) => {
	let result = ''

	const obj = errorsList.find(({ title }) => title === errTitle)
	if (obj) {
		result = obj.description
	}

	return result
}
